import { BaseReducerState } from '../../../services'
import { ActionTypes } from './actions'
import { BillingChartAPIResponse, BillingChartResponse } from './types'

export type BillingChartState = BaseReducerState & {
  data: BillingChartResponse
}

export const initialState: BillingChartState = {
  loading: false,
  success: false,
  message: '',
  data: null,
  error: null,
}

export const billingChartState = (
  state: BillingChartState = initialState,
  action: { type: string; res: any }
): BillingChartState => {
  switch (action.type) {
    case `${ActionTypes.GET_INVOICES_CHART_DATA}_REQUEST`:
      return {
        ...state,
        loading: true,
        success: false,
        message: null,
        data: null,
        error: null,
      }

    case `${ActionTypes.GET_INVOICES_CHART_DATA}_SUCCESS`: {
      const { success, data, message } = <BillingChartAPIResponse>action.res
      return {
        ...state,
        loading: false,
        success,
        message,
        ...(success && data && { data }),
      }
    }
    case `${ActionTypes.GET_INVOICES_CHART_DATA}_FAILURE`:
      const res = <BillingChartAPIResponse>action.res
      const { message } = res || {}
      res.error ??= message
      const { error } = res
      return {
        ...state,
        loading: false,
        success: false,
        message,
        error,
      }

    case `${ActionTypes.GET_INVOICES_CHART_DATA}_RESET`:
      return {
        ...initialState,
      }
  }
  return state
}
